










































import { Component, Prop, Ref, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalDatePicker } from '@/components/modals/ModalDatePicker'
import { masker } from '@/utils'
import { AtomTextField } from '@/components/atoms'

@Component({
  components: {
    ModalDatePicker
  }
})
export default class InputDatePicker extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalDatePicker!: ModalDatePicker

  @Prop({
    type: String
  })
  value!: string

  @Prop({
    type: String
  })
  label!: string

  @Prop({
    type: String
  })
  placeholder!: string

  @Prop({
    type: Boolean,
    default: false
  })
  clearable!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  inputText!: boolean

  @Prop({
    type: String,
    default: '########'
  })
  mask!: string

  @Prop({
    type: Boolean
  })
  error!: boolean

  @Prop({
    type: String
  })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get _value(): string {
    return this.value
  }

  set _value(newVal: string) {
    if (this.mask !== '') {
      this.$emit('input', masker(newVal, this.mask))
      return
    }
    this.$emit('input', newVal)
  }

  showDatePicker(): void {
    this.modalDatePicker.open()
  }

  onClickCalendarIcon(): void {
    this.showDatePicker()
  }

  @Emit('input')
  onInput(date: string): string {
    if (this.mask !== '') {
      return masker(date, this.mask)
    }
    return date
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
